/* import __COLOCATED_TEMPLATE__ from './existing-projects-modal.hbs'; */
import { computed } from '@ember/object';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';
import LSGModalBase from '../lsg/lsg-modal-dialog-base';
import { closeModal } from 'sh-www/utils/modal-controls';
import { EMBER_ROUTE_NAMES } from "../../../constants/routes";

export default LSGModalBase.extend({
  /**
   * Register services
   */
  applicationCommandService : service('commands/application-commands'),
  applicationStateManager: service('state-managers/application'),

  /**
   * @inheritDoc
   */
  propertyDefaults: {
    /**
     * @param {User|null}
     */
    freelancer: null,

    /**
     * @param {Ember.A<Application>}    All the applications that the user could select.
     */
    freelancerProjects: () => A()
  },

  /**
   * @type {String}     URI to the direct hire link for this freelancer.
   */
  _freelancerDirectHireHref: computed('model.freelancer.slug', function() {
    return `/project/create/${this.get('model.freelancer.slug')}`;
  }),

  actions: {
    /**
     * Called when the user clicks to start a new project instead of one of the existing ones with the freelancer.
     */
    onStartNewProjectClicked() {
      this.get('applicationStateManager').setNextRoute(
        EMBER_ROUTE_NAMES.PROJECT__CREATE__DIRECT,
        this.get('model.freelancer.slug'));
    },

    closeModal() {
      closeModal(this);
    },
  }
});
